export function lbsTokg(lb) {
  return lb * 0.453592
}

export function inTocm(inch) {
  return inch * 2.54
}
